<template>
  <form-layout class="form-layout">
    <span slot="title">租赁申请单</span>
    <el-form :model="ruleForm" ref="ruleForm" :rules="rules" slot="apply-box" :inline="true">
      <el-form-item label="发货类型" prop="DeliveryType">
        <el-select class="form-input" v-model="ruleForm.DeliveryType" placeholder="租赁代发／即时发货">
          <el-option
            v-for="item in DeliveryTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单类型" prop="OrderType">
        <el-select v-model="ruleForm.OrderType"  placeholder="固定租期／灵活租期" @change="orderTypeChange">
          <el-option
            v-for="item in OrderTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户合同编号" type="flex" justify="space-between">
        <el-input class="form-input" v-model="ruleForm.CustomerContractCode" placeholder="客户合同编号"></el-input>
      </el-form-item>
      <el-form-item label="联系人姓名" prop="ImmediateDeliveryContactName">
        <el-input class="form-input" v-model="ruleForm.ImmediateDeliveryContactName" placeholder="联系人姓名"></el-input>
      </el-form-item>
      <el-form-item label="联系人电话" prop="ImmediateDeliveryContactPhone">
        <el-input class="form-input" v-model="ruleForm.ImmediateDeliveryContactPhone" placeholder="联系人电话"></el-input>
      </el-form-item>
      <el-form-item label="联系地址" type="flex" justify="space-between" style="width: 600px" prop="ImmediateDeliveryAddress">
        <address-box
          :province-id.sync="ruleForm.ImmediateDeliveryProvinceId"
          :city-id.sync="ruleForm.ImmediateDeliveryCityId"
          :county-id.sync="ruleForm.ImmediateDeliveryCountyId"
          :address.sync="ruleForm.ImmediateDeliveryAddress"
        ></address-box>
      </el-form-item>
    </el-form>
    <div class="table_area" slot="main-content">
      <product-form ref='initAmount' v-for="(item, index) in leaseapplybox" :key="index"
        :product.sync="item"
        :index="index"
        :orderType="ruleForm.OrderType"
        :delivery-type="ruleForm.DeliveryType"
        @delete="deleteItem"></product-form>
    </div>
    <div class="sumbit_box" slot="sumbit_box">
      <el-form  :inline="true" style="padding-top:10px;">
        <el-form-item label="备注">
          <el-input type="textarea" class="form-input" v-model="ruleForm.CustomerNotes"  placeholder="请输入备注" style="width:600px;"></el-input>
        </el-form-item>
      </el-form>
      <p>订单总租金：<span>{{totalAmount|amount}}</span></p>
      <p>保修费用：<span>{{warrantyTotalAmount|amount}}</span></p>
      <p style="padding-bottom:10px;">订单总押金：<span>{{totalDeposit|amount}}</span></p>
      <el-button :disabled="leaseapplybox.length === 0" type="primary" class="pull-right" @click.native="submit">提交并等待客服联系</el-button>
      <el-button @click='cencelBtn' class="pull-right">取消</el-button>
    </div>
  </form-layout>
</template>

<script>
import FormLayout from '@/components/pages/Inventory/FormLayout'
import AddressBox from '@/components/common/Address'
import ProductForm from './LeaseApplyForm'
import o from '@/odata'
import { Loading } from 'element-ui'
import _ from 'lodash'
export default {
  data() {
    return {
      ruleForm: {
        ImmediateDeliveryProvinceId: null,
        ImmediateDeliveryCityId: null,
        ImmediateDeliveryCountyId: null,
        ImmediateDeliveryAddress: null,
        DeliveryType: null,
        OrderType: null,
        ReferenceCode: null,
        ImmediateDeliveryContactName: null,
        ImmediateDeliveryContactPhone: null,
        CustomerNotes: null,
        RegionId: null,
        IsCreatedByCustomer: true,
      },
      rules: {
        ImmediateDeliveryContactName: [{required: true, message: '必填'}],
        ImmediateDeliveryContactPhone: [{required: true, message: '必填'}],
        DeliveryType: [{required: true, message: '必填'}],
        OrderType: [{required: true, message: '必填'}],
        ImmediateDeliveryAddress: [{required: true, message: '必填'}],
      },
      notes: null,
      DeliveryTypes: [
        {label: '租赁代发', value: 'delegateDelivery'},
        {label: '即时发货', value: 'immediateDelivery'},
      ],
      OrderTypes: [
        {label: '灵活租期', value: 'flexibleTerm'},
        {label: '固定租期', value: 'inflexibleTerm'},
      ],
      leaseapplybox: [],
    }
  },
  computed: {
    warrantyTotalAmount() {
      let total = 0
      this.leaseapplybox.forEach(item => {
        total += (item.WarrantySubTotalAmount || 0)
      })
      return total
    },
    totalAmount() {
      let total = 0
      this.leaseapplybox.forEach(item => {
        total += (item.SubTotalRentalAmount || 0)
      })
      return total
    },
    totalDeposit() {
      let total = 0
      this.leaseapplybox.forEach(item => {
        total += item.Deposit
      })
      return total
    },
  },
  methods: {
    /* 改变类型时，限定租赁时长只能为3个月 */
    orderTypeChange() {
      if (this.ruleForm.OrderType === 'flexibleTerm') {
        console.log('this.leaseapplybox', this.leaseapplybox)
        this.leaseapplybox.forEach(function(product) {
          product.RentalPeriod = 3
        }, this)
      }
    },
    cencelBtn: function() {
      this.$router.push('/trust')
    },
    // 初始化租赁订单
    initDate: function() {
      const leaseapplybox = JSON.parse(window.localStorage.getItem('leaseapplybox')).map(item => {
        if (this.ruleForm.RegionId === null) {
          this.ruleForm.RegionId = item.RegionId
        }
        console.log('区域：', this.ruleForm.RegionId)
        return Object.assign({}, item, {
          ProductId: item.ProductId,
          ProductConditionId: item.ConditionId,
          RentalUnitPrice: 0,
          CustomerProductName: null,
          CustomerProductCode: null,
          RentalQuantity: 1,
          RentalPeriods: [],  // 该批次所有租赁周期
          RentalPeriod: 3,  // 选中的租赁周期
          SubTotalRentalAmount: 0,  // 租金费用
          DiscountRate: 1,
          WarrantyMonths: 0,
          Deposit: 0,
        })
      })
      this.$set(this, 'leaseapplybox', leaseapplybox)
    },
    deleteItem: function(index, item) {
      this.$confirm('是否确认删除?', '删除批次', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.leaseapplybox.splice(index, 1)
        window.localStorage.setItem('leaseapplybox', JSON.stringify(this.leaseapplybox))
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
      }).catch(() => {})
    },
    submit: function() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let loading = Loading.service({text: '正在提交订单,请稍后', customClass: 'comfirmLoading'})
          const RentalOrder = o('RentalOrder')
          const form = Object.assign({}, this.ruleForm)
          Object.assign(form, {ProductLines: this.leaseapplybox.map(item => {
            return _.pick(item, [
              'ProductId',
              'ProductConditionId',
              'RentalUnitPrice',
              'CustomerProductName',
              'CustomerProductCode',
              'RentalQuantity',
              'RentalPeriod',
              'DiscountRate',
              'WarrantyMonths',
              'Deposit',
            ])
          })})
          RentalOrder.post(form).save().then((response) => {
            this.$message({
              message: '提交成功',
              type: 'success',
            })
            loading.close()
            this.leaseapplybox = []
            window.localStorage.setItem('leaseapplybox', JSON.stringify(this.leaseapplybox))
            this.$router.push('/trust')
          }).catch((response) => {
            loading.close()
            this.$alert(response)
          })
        }
      })
    },
  },
  components: {
    FormLayout,
    AddressBox,
    ProductForm,
  },
  created() {
    // console.log('this.leaseapplybox')
    // console.log(this.leaseapplybox)
    this.initDate()
  },
  // 挂载组件后调用子组件读取租赁价格
  mounted() {
    // 通过全局引用获取子组件 ref='initAmount'
    const formLayout = this.$refs.initAmount
    for (let i = 0; i < formLayout.length; i++) {
      // 调用子组件计算价格方法
      formLayout[i].initRentPrice()
      formLayout[i].handleCompute()
      formLayout[i].handleComputeDeposit()
    }
  },
}
</script>

<style lang="less" scoped>
.table_area table tbody td{
  padding-right: 5px;
}
.form-input {
  width: 260px;
}
.list-layout .complex-table .sub-row-table .sub-body .text-center{
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}
.main-content{
  .tab{
    .el-tabs__active-bar{
      background-color: rgba(0,0,0,0);
    }
  }
}
.add-btn:hover,.add-btn:focus{
  color: #FFFFFF;
  background: #2283CA;
}
.item-box{
  position: relative;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 25px;
  border: 1px solid #E1E8EE;
  width: 97%;
  .el-select,.el-input{
    width: 100%;
  }
  .delete-btn{
    position: absolute;
    right: -40px;
    top: 35%;
    background-color: #FF4949;
    color: #fff;
    padding: 10px 12px;
    border-radius: 50%;
    border: none;
  }
  table{
    display: inline-block;
    label{
      display: block;
      margin-bottom: 5px;
    }
    td{
      padding-right: 20px;
    }
    td:last-child{
      padding-right: 0;
    }
  }
}
.sumbit_box{
  p{
    text-align: right;
    font-size: 18px;
    color:  #1F2D3D;
    span{
      color: #FF4949;
    }
  }
  .el-button {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// LeaseApplyPage.vue?753c3b46